import enterNumber from './enterNumber'

const install = function (Vue) {
  Vue.directive('enter-number', enterNumber)
}

if (window.Vue) {
  window['enter-number'] = enterNumber
  Vue.use(install); // eslint-disable-line
}

enterNumber.install = install
export default enterNumber
